import type { StartProfilingResponse } from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

type StartScrapeRequest = {
  projectId?: number;
  websiteUrl: string;
};

export function useStartScrape(): UseMutationResult<
  StartProfilingResponse,
  Error,
  StartScrapeRequest
> {
  return useMutation({
    mutationFn: ({ projectId, websiteUrl }: StartScrapeRequest) =>
      apiClient
        .url("/brands/scrape")
        .post({ websiteUrl, ...(projectId !== undefined && { projectId }) })
        .json<StartProfilingResponse>(),
  });
}
